'use client';
import boxHand from '@i/Seller Obligations/seller-obligations.svg';
import boxMeasure from '@i/shipping/boxMeasure.svg';
import laptopLabelEmail from '@i/shipping/laptopLabelEmail.svg';
import lightIcon from '@i/shipping/lightIcon.svg';

import lbs10Icon from '@i/shipping/10lbs.svg';
import lbs20Icon from '@i/shipping/20lbs.svg';
import lbs3Icon from '@i/shipping/3lbs.svg';

import deliveryTrackingIcon from '@i/shipping/deliverytracking.svg';
import dollarHandIcon from '@i/shipping/dollarhand.svg';
import laptopSecureIcon from '@i/shipping/laptopsecure.svg';

import boxChecklist from '@i/shipping/boxchecklist.svg';
import boxTimer from '@i/shipping/boxtimer.svg';
import deliveryProgress from '@i/shipping/deliveryprogress.svg';
import printIcon from '@i/shipping/print.svg';

import Button from '@ui/Button';
import SafeImage from '@ui/SafeImage';
import Link from 'next/link';

const Shipping = () => {
  return (
    <>
      {/* Header */}
      <div className="flex w-full justify-center bg-brand-light-dark-gray">
        <div className="relative flex h-[40rem] w-full max-w-[150rem]  items-start justify-center bg-shipping-banner-mobile  bg-[length:100%_100%] bg-no-repeat px-[1.6rem] pt-[4rem] sm:text-brand-black md:flex-row md:items-center md:justify-start md:bg-shipping-banner md:px-[5rem] md:pt-0 xl:px-[12rem]">
          <div>
            <h1 className="mb-[0.8rem] text-center text-[3.2rem] font-semibold md:mb-[1.6rem] md:text-start md:text-[4rem]">
              Shipping. Made Easy.
            </h1>
            <p className="text-center text-[1.8rem] md:text-start ">
              Save money and time by shipping with MX Locker.
            </p>
          </div>
        </div>
      </div>
      {/* Shipping Details Section */}
      <div className=" mx-auto flex w-full max-w-[120rem] flex-col items-center px-[1.6rem] py-[4rem] md:px-[5rem] md:py-[10rem] xl:px-[0rem] ">
        <div className="mb-[4rem] text-center md:mb-[6.4rem]">
          <h2 className="mb-[1.6rem] text-[2.4rem] font-semibold md:text-[3.2rem]">
            Shipping with MX Locker.
          </h2>
          <p className="text-[1.6rem] leading-[2.4rem] text-brand-extreme-lightest-black">
            Sell with ease and comfort - No meetups necessary. We take the
            guesswork out of shipping.
          </p>
        </div>
        <div className=" mb-[4rem] flex w-full flex-col gap-[2.4rem] md:mb-[6.4rem] md:flex-row">
          <div className="w-full  md:w-1/3">
            <div className="mb-[1.6rem] flex h-[18rem] w-full items-center justify-center bg-brand-light-white md:mb-[2.4rem]">
              <SafeImage
                src={boxMeasure}
                alt="Icon"
                className="h-[9rem] w-[9rem] "
              />
            </div>
            <div>
              <p className="text-[2.4rem] font-semibold">
                Enter package details
              </p>
              <p className="text-[1.6rem] font-normal text-brand-extreme-lightest-black">
                Use our recommended box size and weights for riding gear and
                bike parts.
              </p>
            </div>
          </div>
          <div className="w-full  md:w-1/3">
            <div className="mb-[1.6rem] flex h-[18rem] w-full items-center justify-center bg-brand-light-white md:mb-[2.4rem] ">
              <SafeImage
                src={laptopLabelEmail}
                alt="Icon"
                className="h-[5.8rem] w-[6.8rem] "
              />
            </div>
            <div>
              <p className="text-[2.4rem] font-semibold">Receive a label</p>
              <p className="text-[1.6rem] font-normal text-brand-extreme-lightest-black">
                Once your item sells, receive a prepaid label directly from MX
                Locker.
              </p>
            </div>
          </div>
          <div className="w-full  md:w-1/3">
            <div className="mb-[1.6rem] flex h-[18rem] w-full items-center justify-center bg-brand-light-white md:mb-[2.4rem]">
              <SafeImage
                src={boxHand}
                alt="Icon"
                className="h-[5.8rem] w-[6.8rem] "
              />
            </div>
            <div>
              <p className="text-[2.4rem] font-semibold">Pack & Ship</p>
              <p className="text-[1.6rem] font-normal text-brand-extreme-lightest-black">
                Tracking will automatically be added to your order for your
                buyer.
              </p>
            </div>
          </div>
        </div>
        <div className="mb-[2.4rem] flex items-center gap-[0.8rem] bg-brand-light-red px-[1.6rem] py-[1.2rem] md:py-[1.95rem]">
          <SafeImage
            src={lightIcon}
            alt="light Bulb Icon"
            className="h-[3.6rem] w-[3.6rem]"
          />
          MX Locker&apos;s prepaid labels give you all the benefits. Making
          shipping even easier.
        </div>
      </div>

      {/* Shipping Option Section */}
      <div className="flex w-full  justify-center bg-brand-light-white">
        <div className="flex w-full max-w-[120rem] flex-col items-center  px-[1.6rem] py-[4rem] md:px-[5rem] md:py-[10rem] xl:px-[0rem]">
          <div className="mb-[4rem] flex w-full flex-col justify-center text-center md:mb-[6.4rem] ">
            <h2 className="mb-[1.6rem] text-[2.4rem] font-semibold md:text-[3.2rem]">
              Pick a shipping option
            </h2>
            <p className="text-[1.6rem] leading-[2.4rem] text-brand-extreme-lightest-black">
              We recommend using an MX Locker shipping label.
            </p>
          </div>

          <div className="mb-[4rem] flex w-full flex-col items-center justify-center  gap-[1.6rem] md:mb-[6.4rem] xl:flex-row xl:gap-0">
            <div className="flex min-h-[46rem] w-full flex-col items-center  px-[4rem] shadow-lg xl:w-1/3">
              <div className="mb-[3.2rem] w-max bg-brand-extreme-lightest-black px-[1.2rem] py-[0.55rem] text-[1.4rem] leading-[2.1rem] text-brand-white">
                Oversized items
              </div>
              <div className="mb-[2.4rem]">
                <h2 className="mb-[0.8rem] text-center text-[2.4rem] font-semibold">
                  Ship on your own
                </h2>
                <p className="text-center text-[1.6rem] leading-[2.4rem]">
                  More expensive. Experienced sellers.
                </p>
              </div>
              <div className="w-full">
                <div className="mb-[2.4rem]">
                  <p className="mb-[0.95rem] text-[1.6rem] font-semibold leading-[2.4rem]">
                    You get :
                  </p>
                  <div className="flex items-center gap-[1.26rem] px-[0.5rem] pb-[0.7rem]">
                    <SafeImage
                      src={'tick.svg'}
                      alt="tick mark"
                      className="h-[1.1rem] w-[1.4rem]"
                    />
                    Choose your shipping carrier
                  </div>
                  <div className="flex items-center gap-[1.26rem] px-[0.5rem]">
                    <SafeImage
                      src={'tick.svg'}
                      alt="tick mark"
                      className="h-[1.1rem] w-[1.4rem]"
                    />
                    More pricing options
                  </div>
                </div>
                <div className="mb-[2.55rem]">
                  <p className="mb-[0.95rem] text-[1.6rem] font-semibold leading-[2.4rem]">
                    Recommended for :
                  </p>
                  <div className=" flex items-center gap-[1.26rem] px-[0.5rem] pb-[0.7rem]">
                    <SafeImage
                      src={'tick.svg'}
                      alt="tick mark"
                      className="h-[1.1rem] w-[1.4rem]"
                    />
                    Items over 150 lbs or 45&apos; in length
                  </div>
                </div>
              </div>
            </div>

            <div className="flex min-h-[50rem] w-full flex-col  items-center border-2 border-brand-secondary px-[4rem] shadow-lg xl:w-1/3 ">
              <div className=" mb-[3.2rem] flex w-max items-center gap-1 bg-brand-secondary px-[1.2rem] py-[0.55rem] text-[1.4rem] leading-[2.1rem] text-brand-white">
                <span>
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.4997 13.9993H5.83301V5.33268L10.4997 0.666016L11.333 1.49935C11.4108 1.57713 11.4748 1.68268 11.525 1.81602C11.5748 1.94935 11.5997 2.07713 11.5997 2.19935V2.43268L10.8663 5.33268H14.4997C14.8552 5.33268 15.1663 5.46602 15.433 5.73268C15.6997 5.99935 15.833 6.31046 15.833 6.66602V7.99935C15.833 8.07713 15.8246 8.16046 15.8077 8.24935C15.7912 8.33824 15.7663 8.42157 15.733 8.49935L13.733 13.1993C13.633 13.4216 13.4663 13.6105 13.233 13.766C12.9997 13.9216 12.7552 13.9993 12.4997 13.9993ZM4.49967 5.33268V13.9993H1.83301V5.33268H4.49967Z"
                      fill="white"
                    />
                  </svg>
                </span>{' '}
                Recommended
              </div>

              <div className="mb-[2.4rem]">
                <h2 className="mb-[0.8rem] flex justify-center text-center text-[2.4rem] font-semibold">
                  <SafeImage
                    src={'mx logo.png'}
                    alt="tick mark"
                    className="h-[2.4rem] w-[17rem]"
                  />
                </h2>
                <p className="text-center text-[1.6rem] leading-[2.4rem]">
                  <span className="font-semibold text-brand-secondary">
                    {' '}
                    Save up to 60%
                  </span>{' '}
                  off retail carrier rates.
                </p>
              </div>
              <div className="w-full">
                <div className="mb-[2.4rem]">
                  <p className="mb-[0.95rem] text-[1.6rem] font-semibold leading-[2.4rem]">
                    You get :
                  </p>
                  <div className="flex items-center gap-[1.26rem] px-[0.5rem] pb-[0.7rem]">
                    <SafeImage
                      src={'tick.svg'}
                      alt="tick mark"
                      className="h-[1.1rem] w-[1.4rem]"
                    />
                    An MX Locker label sent to you
                  </div>
                  <div className="flex items-center gap-[1.26rem] px-[0.5rem] pb-[0.7rem]">
                    <SafeImage
                      src={'tick.svg'}
                      alt="tick mark"
                      className="h-[1.1rem] w-[1.4rem]"
                    />
                    Track your package anytime
                  </div>
                  <div className="flex items-center gap-[1.26rem] px-[0.5rem] pb-[0.7rem]">
                    <SafeImage
                      src={'tick.svg'}
                      alt="tick mark"
                      className="h-[1.1rem] w-[1.4rem]"
                    />
                    Reduced postage rates
                  </div>
                  <div className="flex items-center gap-[1.26rem] px-[0.5rem] pb-[0.7rem]">
                    <SafeImage
                      src={'tick.svg'}
                      alt="tick mark"
                      className="h-[1.1rem] w-[1.4rem]"
                    />
                    More money in your pocket
                  </div>
                  <div className="flex items-center gap-[1.26rem] px-[0.5rem] pb-[0.7rem]">
                    <SafeImage
                      src={'tick.svg'}
                      alt="tick mark"
                      className="h-[1.1rem] w-[1.4rem]"
                    />
                    Time saved
                  </div>
                </div>
                <div className="mb-[2.55rem]">
                  <p className="mb-[0.95rem] text-[1.6rem] font-semibold leading-[2.4rem]">
                    Recommended for :
                  </p>
                  <div className="flex items-center gap-[1.26rem] px-[0.5rem] pb-[0.7rem]">
                    <SafeImage
                      src={'tick.svg'}
                      alt="tick mark"
                      className="h-[1.1rem] w-[1.4rem]"
                    />
                    The best shipping experience
                  </div>
                  <div className="flex items-center gap-[1.26rem] px-[0.5rem] pb-[0.7rem]">
                    <SafeImage
                      src={'tick.svg'}
                      alt="tick mark"
                      className="h-[1.1rem] w-[1.4rem]"
                    />
                    Any user
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-[1rem] flex  min-h-[46rem] w-full flex-col items-center px-[4rem] shadow-lg xl:w-1/3">
              <div className="mb-[3.2rem] w-max bg-brand-extreme-lightest-black px-[1.2rem] py-[0.55rem] text-[1.4rem] leading-[2.1rem] text-brand-white">
                Pack & Ship
              </div>
              <div className="mb-[2.4rem]">
                <h2 className="mb-[0.8rem] text-center text-[2.4rem] font-semibold">
                  Pack & Ship
                </h2>
                <p className="text-center text-[1.6rem] leading-[2.4rem]">
                  Print a label after your item sells with MX Locker.
                </p>
              </div>
              <div className="w-full">
                <div className="mb-[2.55rem]">
                  <p className="mb-[0.95rem] text-[1.6rem] font-semibold leading-[2.4rem]">
                    You get :
                  </p>
                  <div className="flex items-center gap-[1.26rem] px-[0.5rem] pb-[0.7rem]">
                    <SafeImage
                      src={'tick.svg'}
                      alt="tick mark"
                      className="h-[1.1rem] w-[1.4rem]"
                    />
                    Contact-free pick up
                  </div>
                  <div className="flex items-center gap-[1.26rem] px-[0.5rem] pb-[0.7rem]">
                    <SafeImage
                      src={'tick.svg'}
                      alt="tick mark"
                      className="h-[1.1rem] w-[1.4rem]"
                    />
                    Same-day pick up and delivery
                  </div>
                  <div className="flex items-center gap-[1.26rem] px-[0.5rem] pb-[0.7rem]">
                    <SafeImage
                      src={'tick.svg'}
                      alt="tick mark"
                      className="h-[1.1rem] w-[1.4rem]"
                    />
                    A time-saving option with no meetup required
                  </div>
                </div>
                <div className="mb-[2.4rem]">
                  <p className="mb-[0.95rem] text-[1.6rem] font-semibold leading-[2.4rem]">
                    Recommended for :
                  </p>
                  <div className="flex items-center gap-[1.26rem] px-[0.5rem] pb-[0.7rem]">
                    <SafeImage
                      src={'tick.svg'}
                      alt="tick mark"
                      className="h-[1.1rem] w-[1.4rem]"
                    />
                    Fragile and bulky items that require extra care in transit
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Shipping Charges Section */}
      <div className="w-full max-w-[120rem] px-[1.6rem] py-[4rem] md:px-[5rem] md:py-[10rem] xl:px-[0rem]">
        {/* Header Section */}
        <div className="mb-[4rem] flex w-full flex-col justify-center text-center md:mb-[6.4rem] ">
          <h2 className="mb-[1.6rem] text-[2.4rem] font-semibold md:text-[3.2rem]">
            Shipping price examples
          </h2>
          <p className="text-[1.6rem] leading-[2.4rem] text-brand-extreme-lightest-black">
            Sample sizes and weights based on items selling on MX Locker.
          </p>
        </div>

        {/* for larger screen */}
        <div className="hidden w-full xl:flex">
          <div className="flex w-full">
            <div className=" flex w-[30%] flex-col justify-end">
              <div className="h-[25rem] w-full"></div>

              <div className="flex h-[10.7rem]  flex-col justify-center bg-brand-darkest-white p-[2.4rem]">
                <h3 className="mb-[0.4rem]  text-[2.4rem] font-semibold">
                  Ship on your own
                </h3>
                <p className=" text-[1.6rem] leading-[2.4rem]">
                  More expensive. Experienced sellers.
                </p>
              </div>

              <div className="flex h-[10.7rem] flex-col justify-center p-[2.4rem]">
                <SafeImage
                  src={'mx logo.png'}
                  alt="tick mark"
                  className="mb-[0.8rem] h-[2.4rem] w-[17rem]"
                />
                <p className="text-[1.6rem] leading-[2.4rem]">
                  <span className="text-brand-secondary"> Save up to 60% </span>
                  off retail carrier rates.
                </p>
              </div>
            </div>

            <div className="flex w-[23%] flex-col justify-end">
              <div className="flex h-[25rem] w-full flex-col items-center">
                <SafeImage
                  src={lbs3Icon}
                  alt="tick mark"
                  className="mb-[1.6rem] h-[13rem] w-[18rem]"
                />
                <p className="text-[1.8rem] font-semibold leading-[2.5rem]">
                  Small up to 3 Lbs
                </p>
                <p className="text-[1.6rem] font-normal">
                  Package size 10x8x6 in
                </p>
              </div>

              <div className="flex h-[10.7rem] items-center justify-center bg-brand-darkest-white p-[2.4rem]">
                <p className=" text-center text-[1.8rem] font-semibold leading-[2.4rem]">
                  $15.26
                </p>
              </div>

              <div className="flex h-[10.7rem] items-center justify-center p-[2.4rem]">
                <p className="text-center text-[2.2rem] font-semibold">
                  <span className="text-brand-secondary">$8.50</span>
                </p>
              </div>
            </div>

            <div className="flex w-[23%] flex-col justify-end">
              <div className="flex h-[25rem] w-full flex-col items-center">
                <SafeImage
                  src={lbs10Icon}
                  alt="tick mark"
                  className="mb-[1.6rem] h-[13rem] w-[18rem]"
                />
                <p className="text-[1.8rem] font-semibold leading-[2.5rem]">
                  Medium up to 10 Lbs
                </p>
                <p className="text-[1.6rem] font-normal">
                  Package size 16x12x12 in
                </p>
              </div>

              <div className="flex h-[10.7rem] items-center justify-center bg-brand-darkest-white p-[2.4rem]">
                <p className=" text-center text-[1.8rem] font-semibold leading-[2.4rem]">
                  $47.83
                </p>
              </div>

              <div className="flex h-[10.7rem] items-center justify-center p-[2.4rem]">
                <p className="text-center text-[2.2rem] font-semibold">
                  <span className="text-brand-secondary">$23.52</span>
                </p>
              </div>
            </div>

            <div className="flex w-[23%] flex-col justify-end">
              <div className="flex h-[25rem] w-full flex-col items-center">
                <SafeImage
                  src={lbs20Icon}
                  alt="lbs20Icon"
                  className="mb-[1.6rem] h-[13rem] w-[18rem]"
                />
                <p className="text-[1.8rem] font-semibold leading-[2.5rem]">
                  Large up to 40 lbs
                </p>
                <p className="text-[1.6rem] font-normal">
                  Package size 42x14x4 in
                </p>
              </div>

              <div className="flex h-[10.7rem] items-center justify-center bg-brand-darkest-white p-[2.4rem]">
                <p className=" text-center text-[1.8rem] font-semibold leading-[2.4rem]">
                  $89.34
                </p>
              </div>

              <div className="flex h-[10.7rem] items-center justify-center p-[2.4rem]">
                <p className="text-center text-[2.2rem] font-semibold">
                  <span className="text-brand-secondary">$43.56</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* for smaller screen */}
        <div className="flex w-full flex-col gap-[1.6rem] xl:hidden">
          <div className="border-2 border-brand-lighter-gray">
            <div className="flex h-[24rem] w-full flex-col items-center">
              <SafeImage
                src={lbs3Icon}
                alt="tick mark"
                className="mb-[1.6rem] h-[13rem] w-[18rem]"
              />
              <p className="text-[1.8rem] font-semibold leading-[2.5rem]">
                Small up to 3 Lbs
              </p>
              <p className="text-[1.6rem] font-normal">
                Package size 10x8x6 in
              </p>
            </div>
            <div className="flex w-full border-t-2 border-brand-lighter-gray">
              <div className="w-1/2 items-center justify-start border-r-2 border-brand-lighter-gray p-[1.6rem]">
                <div className="flex flex-col justify-center">
                  <p className="mb-[1.6rem] text-[1.8rem] font-semibold">
                    $15.26
                  </p>
                  <h3 className="mb-[0.4rem]  text-[1.5rem] font-semibold">
                    Ship on your own
                  </h3>
                  <p className=" text-[1.4rem] leading-[2.4rem]">
                    More expensive. Experienced sellers.
                  </p>
                </div>
              </div>
              <div className="justify-star w-1/2 items-center p-[1.6rem]">
                <div className="flex flex-col justify-center">
                  <p className="mb-[1.4rem] text-[2rem] font-semibold">
                    <span className="text-brand-secondary">$8.50</span>
                  </p>
                  <SafeImage
                    src={'mx logo.png'}
                    alt="tick mark"
                    className="mb-[0.8rem] h-[1.6rem] w-[11rem]"
                  />
                  <p className=" text-[1.4rem] leading-[2.4rem]">
                    <span className="font-semibold">Save up to 60% </span>
                    off retail carrier rates.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="border-2 border-brand-lighter-gray">
            <div className="flex h-[24rem] w-full flex-col items-center">
              <SafeImage
                src={lbs10Icon}
                alt="tick mark"
                className="mb-[1.6rem] h-[13rem] w-[18rem]"
              />
              <p className="text-[1.8rem] font-semibold leading-[2.5rem]">
                Medium up to 10 Lbs
              </p>
              <p className="text-[1.6rem] font-normal">
                Package size 16x12x12 in
              </p>
            </div>
            <div className="flex w-full border-t-2 border-brand-lighter-gray">
              <div className="w-1/2 items-center justify-start border-r-2 border-brand-lighter-gray p-[1.6rem]">
                <div className="flex flex-col justify-center">
                  <p className="mb-[1.6rem] text-[1.8rem] font-semibold">
                    $47.83
                  </p>
                  <h3 className="mb-[0.4rem]  text-[1.5rem] font-semibold">
                    Ship on your own
                  </h3>
                  <p className=" text-[1.4rem] leading-[2.4rem]">
                    More expensive. Experienced sellers.
                  </p>
                </div>
              </div>
              <div className="w-1/2 items-center justify-start p-[1.6rem]">
                <div className="flex flex-col justify-center">
                  <p className="mb-[1.4rem] text-[2rem] font-semibold">
                    <span className="text-brand-secondary">$23.52</span>
                  </p>
                  <SafeImage
                    src={'mx logo.png'}
                    alt="tick mark"
                    className="mb-[0.8rem] h-[1.6rem] w-[11rem]"
                  />
                  <p className=" text-[1.4rem] leading-[2.4rem]">
                    <span className="font-semibold">Save up to 60% </span>
                    off retail carrier rates.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="border-2 border-brand-lighter-gray">
            <div className="flex h-[24rem] w-full flex-col items-center">
              <SafeImage
                src={lbs20Icon}
                alt="lbs20Icon"
                className="mb-[1.6rem] h-[13rem] w-[18rem]"
              />
              <p className="text-[1.8rem] font-semibold leading-[2.5rem]">
                Large up to 40 lbs
              </p>
              <p className="text-[1.6rem] font-normal">
                Package size 42x14x4 in
              </p>
            </div>
            <div className="flex w-full border-t-2 border-brand-lighter-gray">
              <div className="w-1/2 items-center justify-start border-r-2 border-brand-lighter-gray p-[1.6rem]">
                <div className="flex flex-col justify-center">
                  <p className="mb-[1.6rem] text-[1.8rem] font-semibold">
                    $89.34
                  </p>
                  <h3 className="mb-[0.4rem]  text-[1.5rem] font-semibold">
                    Ship on your own
                  </h3>
                  <p className=" text-[1.4rem] leading-[2.4rem]">
                    More expensive. Experienced sellers.
                  </p>
                </div>
              </div>
              <div className="w-1/2 items-center justify-start p-[1.6rem]">
                <div className="flex flex-col justify-center">
                  <p className="mb-[1.4rem] text-[2rem] font-semibold">
                    <span className="text-brand-secondary">$43.56</span>
                  </p>
                  <SafeImage
                    src={'mx logo.png'}
                    alt="tick mark"
                    className="mb-[0.8rem] h-[1.6rem] w-[11rem]"
                  />
                  <p className=" text-[1.4rem] leading-[2.4rem]">
                    <span className="font-semibold">Save up to 60% </span>
                    off retail carrier rates.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Benefit of shipping Section */}
      <div className="flex w-full max-w-[120rem] flex-col items-center px-[1.6rem] py-[4rem] md:px-[5rem] md:py-[10rem] xl:px-[0rem] ">
        <div className="mb-[4rem] text-center md:mb-[6.4rem]">
          <h2 className="mb-[1.6rem] text-[2.4rem] font-semibold md:text-[3.2rem]">
            The benefits of using an MX Locker shipping label
          </h2>
          <p className="text-[1.6rem] leading-[2.4rem] text-brand-extreme-lightest-black">
            MX Locker&apos;s labels makes shipping even easier and saves you
            money.
          </p>
        </div>
        <div className=" mb-[4rem] flex w-full flex-col gap-[4rem] md:mb-[6.4rem] md:flex-row md:gap-0">
          <div className="w-full  px-[1.6rem] md:w-1/3 md:px-[2.4rem]">
            <SafeImage
              src={dollarHandIcon}
              alt="Icon"
              className="mb-[1.6rem] h-[8rem] w-[8rem] md:mb-[2.4rem]"
            />
            <div>
              <p className="mb-[0.8rem] text-[2.4rem] font-semibold leading-[3.1rem] ">
                Save up to 60%
              </p>
              <p className="text-[1.6rem] font-normal leading-[2.4rem] text-brand-extreme-lightest-black">
                Buying a label through MX Locker could save you money.
              </p>
            </div>
          </div>
          <div className="w-full  px-[1.6rem] md:w-1/3 md:px-[2.4rem]">
            <SafeImage
              src={deliveryTrackingIcon}
              alt="Icon"
              className="mb-[1.6rem] h-[8rem] w-[8rem] md:mb-[2.4rem]"
            />
            <div>
              <p className="mb-[0.8rem] text-[2.4rem] font-semibold leading-[3.1rem] ">
                All access tracking
              </p>
              <p className="text-[1.6rem] font-normal leading-[2.4rem] text-brand-extreme-lightest-black">
                Track your item on our website or on the app anytime. This means
                you can see where your package is at all times.
              </p>
            </div>
          </div>
          <div className="w-full  px-[1.6rem] md:w-1/3 md:px-[2.4rem]">
            <SafeImage
              src={laptopSecureIcon}
              alt="Icon"
              className="mb-[1.6rem] h-[8rem] w-[8rem] md:mb-[2.4rem]"
            />
            <div>
              <p className="mb-[0.8rem] text-[2.4rem] font-semibold leading-[3.1rem] ">
                Label e-mailed to you
              </p>
              <p className="text-[1.6rem] font-normal leading-[2.4rem] text-brand-extreme-lightest-black">
                Buy a label through MX Locker and automatically get it sent to
                your e-mail. Just print and ship.
              </p>
            </div>
          </div>
        </div>
        <div className="mb-[2.4rem] flex max-w-[72.6rem] items-center gap-[0.8rem] bg-brand-light-red px-[1.6rem] py-[1.2rem]  md:py-[1.95rem]">
          <SafeImage
            src={lightIcon}
            alt="light Bulb Icon"
            className="h-[3.6rem] w-[3.6rem]"
          />
          <p className="text-[1.4rem]">
            Using our app will make selling and buying even easier. Easier
            selling means more money in your pocket.{' '}
            <span className="font-semibold">Get MX Locker App </span> now on{' '}
            <span className="font-semibold text-brand-secondary">
              <Link
                href="https://apps.apple.com/us/app/mx-locker/id1543819006"
                target="_blank"
              >
                App Store
              </Link>
            </span>{' '}
            or{' '}
            <span className="font-semibold text-brand-secondary">
              <Link
                href="https://play.google.com/store/search?q=mxlocker&c=apps"
                target="_blank"
              >
                Play Store
              </Link>
            </span>
            .
          </p>
        </div>
      </div>

      {/* Steps after item Sold Section */}
      <div className="py-[4rem]md:px-[5rem] flex w-full max-w-[120rem] flex-col items-center px-[1.6rem] md:py-[10rem] xl:px-[0rem] ">
        <div className="mb-[4rem] text-center md:mb-[6.4rem]">
          <h2 className="mb-[1.6rem] text-[2.4rem] font-semibold md:text-[3.2rem]">
            Your item sold. Now what?!
          </h2>
          <p className="text-[1.6rem] leading-[2.4rem] text-brand-extreme-lightest-black">
            Here&apos;s how to ship.
          </p>
        </div>

        <div className=" mb-[4rem] flex w-full flex-col flex-wrap gap-[1.6rem] md:mb-[6.4rem] md:flex-row md:gap-0">
          <div className="w-full p-[1.6rem] md:w-1/2 md:p-[2.4rem] ">
            <SafeImage
              src={boxChecklist}
              alt="Icon"
              className="mb-[1.95rem] h-[8rem] w-[8rem] md:mb-[2.5rem]"
            />
            <div>
              <div className="mb-[0.8rem] flex items-center gap-[1.4rem]">
                <span className="flex h-[2.4rem] w-[2.4rem] items-center justify-center rounded-[50%] bg-brand-secondary text-brand-white">
                  1
                </span>
                <p className=" text-[2.2rem] font-semibold  ">
                  Package your item with care.
                </p>
              </div>
              <p className="text-[1.6rem] font-normal leading-[2.4rem] text-brand-extreme-lightest-black">
                Safe shipping starts with the right box. We recommend choosing a
                sturdy box with about 2 inches of extra space on each side of
                the item. This will allow for plenty of room for padding.
              </p>
            </div>
          </div>
          <div className="w-full p-[1.6rem] md:w-1/2 md:p-[2.4rem] ">
            <SafeImage
              src={printIcon}
              alt="Icon"
              className="mb-[1.95rem] h-[8rem] w-[8rem] md:mb-[2.5rem]"
            />
            <div>
              <div className="mb-[0.8rem] flex items-center gap-[1.4rem]">
                <span className="flex h-[2.4rem] w-[2.4rem] items-center justify-center rounded-[50%] bg-brand-secondary text-brand-white">
                  2
                </span>
                <p className=" text-[2.2rem] font-semibold  ">
                  Print your label.
                </p>
              </div>
              <p className="text-[1.6rem] font-normal leading-[2.4rem] text-brand-extreme-lightest-black">
                Save up to 60% OFF shipping rates by purchasing a label through
                MX Locker. Seal the package and tape the shipping label to the
                top of the package.
              </p>
            </div>
          </div>
          <div className="w-full p-[1.6rem] md:w-1/2 md:p-[2.4rem] ">
            <SafeImage
              src={boxTimer}
              alt="Icon"
              className="mb-[1.95rem] h-[8rem] w-[8rem] md:mb-[2.5rem]"
            />
            <div>
              <div className="mb-[0.8rem] flex items-center gap-[1.4rem]">
                <span className="flex h-[2.4rem] w-[2.4rem] items-center justify-center rounded-[50%] bg-brand-secondary text-brand-white">
                  3
                </span>
                <p className=" text-[2.2rem] font-semibold  ">
                  Ship within 3 business days.
                </p>
              </div>
              <p className="text-[1.6rem] font-normal leading-[2.4rem] text-brand-extreme-lightest-black">
                Once your order is packaged, it&apos;s time to hand it off to
                the carrier. We have partnered with multiple shipping providers
                so a drop-off option is always within reach.
              </p>
            </div>
          </div>
          <div className="w-full p-[1.6rem] md:w-1/2 md:p-[2.4rem] ">
            <SafeImage
              src={deliveryProgress}
              alt="Icon"
              className="mb-[1.95rem] h-[8rem] w-[8rem] md:mb-[2.5rem]"
            />
            <div>
              <div className="mb-[0.8rem] flex items-center gap-[1.4rem]">
                <span className="flex h-[2.4rem] w-[2.4rem] items-center justify-center rounded-[50%] bg-brand-secondary text-brand-white">
                  4
                </span>
                <p className=" text-[2.2rem] font-semibold  ">
                  Confirm your shipment.
                </p>
              </div>
              <p className="text-[1.6rem] font-normal leading-[2.4rem] text-brand-extreme-lightest-black">
                When you print a label through MX Locker, tracking information
                is automatically applied to the order and sent to the customer.
              </p>
            </div>
          </div>
        </div>
        <div className="mb-[2.4rem] flex items-center gap-[0.8rem] bg-brand-light-red px-[1.6rem] py-[1.2rem]  md:py-[1.95rem]">
          <SafeImage
            src={lightIcon}
            alt="light Bulb Icon"
            className="h-[3.6rem] w-[3.6rem]"
          />
          <p className="text-[1.4rem]">
            Make sure you measure your item and box it correctly. This could
            save you time and money on shipping using the right box.
          </p>
        </div>
      </div>

      {/* Become a Seller Section */}
      <div
        className="flex h-[40rem] w-full items-start justify-center bg-selling-banner-mobile   bg-[length:100%_40rem]  bg-no-repeat px-[1.6rem] 
      py-[4rem] sm:bg-selling-banner md:items-center   md:px-[5rem] xl:px-[12rem]"
      >
        <div className="flex h-full w-full max-w-[120rem] flex-col items-center justify-center">
          <h2 className="mb-[4rem] text-[2.4rem] font-semibold text-brand-white sm:text-[3rem] xl:text-[4rem]">
            Ready to sell? Let&apos;s get started.
          </h2>
          <Button
            text="Become a Seller"
            type="secondary"
            width={'mid'}
            height="small"
          />
        </div>
      </div>
    </>
  );
};

export default Shipping;
